import { render } from "./WizardSteps.vue?vue&type=template&id=736d75ae&scoped=true"
import script from "./WizardSteps.vue?vue&type=script&lang=js"
export * from "./WizardSteps.vue?vue&type=script&lang=js"

import "./WizardSteps.vue?vue&type=style&index=0&id=736d75ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736d75ae"]])

export default __exports__